export const AREA_CODE_LIST = [
  {key: 'AT', value: '+43 (AT)'},
  {key: 'BE', value: '+32 (BE)'},
  {key: 'DE', value: '+49 (DE)'},
  {key: 'DK', value: '+45 (DK)'},
  {key: 'ES', value: '+34 (ES)'},
  {key: 'FI', value: '+358 (FI)'},
  {key: 'FR', value: '+33 (FR)'},
  {key: 'HU', value: '+36 (HU)'},
  {key: 'IE', value: '+353 (IE)'},
  {key: 'IS', value: '+354 (IS)'},
  {key: 'IT', value: '+39 (IT)'},
  {key: 'LU', value: '+352 (LU)'},
  {key: 'NL', value: '+31 (NL)'},
  {key: 'NO', value: '+47 (NO)'},
  {key: 'PL', value: '+48 (PL)'},
  {key: 'PT', value: '+351 (PT)'},
  {key: 'RO', value: '+40 (RO)'},
  {key: 'RU', value: '+7 (RU)'},
  {key: 'SE', value: '+46 (SE)'},
  {key: 'SK', value: '+421 (SK)'},
  {key: 'CH', value: '+41 (CH)'},
  {key: 'TR', value: '+90 (TR)'},
  {key: 'US', value: '+1 (US)'},
  {key: 'ZA', value: '+27 (ZA)'},
  {key: 'CZ', value: '+420 (CZ)'},
  {key: 'GB', value: '+44 (GB)'},
  {key: 'IL', value: '+972 (IL)'},
  {key: 'UA', value: '+38 (UA)'}
];
